interface MiniCalendarProps {
  assignments: { date: string }[];
  month: Date;
}

const DAY_NAMES = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

export function MiniCalendar({ assignments, month }: MiniCalendarProps) {
  const year = month.getFullYear();
  const mon = month.getMonth();
  const today = new Date();
  const todayStr = today.toISOString().slice(0, 10);

  const assignedDates = new Set(assignments.map((a) => a.date.slice(0, 10)));

  const firstDay = new Date(year, mon, 1).getDay();
  const daysInMonth = new Date(year, mon + 1, 0).getDate();

  const cells: (number | null)[] = [];
  for (let i = 0; i < firstDay; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);

  const monthLabel = month.toLocaleString('default', { month: 'long', year: 'numeric' });

  return (
    <div className="select-none">
      <div className="text-sm font-medium text-brand-charcoal mb-1">{monthLabel}</div>
      <div className="grid grid-cols-7 text-center text-xs text-slate-500 mb-1">
        {DAY_NAMES.map((d) => (
          <span key={d}>{d}</span>
        ))}
      </div>
      <div className="grid grid-cols-7 text-center text-xs gap-y-1">
        {cells.map((day, i) => {
          if (!day) return <span key={i} />;
          const dateStr = `${year}-${String(mon + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
          const isToday = dateStr === todayStr;
          const hasAssignment = assignedDates.has(dateStr);
          return (
            <div key={i} className="flex flex-col items-center">
              <span
                className={`inline-flex items-center justify-center w-6 h-6 rounded-full text-xs ${
                  isToday ? 'ring-2 ring-brand-orange ring-offset-1 font-bold text-brand-charcoal' : 'text-brand-charcoal'
                }`}
              >
                {day}
              </span>
              {hasAssignment && (
                <span className="w-1.5 h-1.5 rounded-full bg-brand-blue mt-0.5" />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
